import { useState } from "react";
import { useNavigate } from "react-router";
import { useUrlProvider } from "../../useUrlProvider";
import { IInternalAssessmentGroupHeaderProps } from "./InternalAssessmentGroupHeader";

export default function useInternalAssessmentGroupHeader(props: IInternalAssessmentGroupHeaderProps) {
    const navigate = useNavigate();
    const { getInternalAssessmentGroupsUrl, getInternalAssessmentGroupDraftUrl } = useUrlProvider();

    const [showEditDialog, setShowEditDialog] = useState(false);
    const [showDeleteDialog, setShowDeleteDialog] = useState(false);

    const onAddRecipientsClick = () => navigate(getInternalAssessmentGroupDraftUrl(props.internalAssessmentGroup!.id));

    const onDeleted = () => {
        setShowDeleteDialog(false);
        navigate(getInternalAssessmentGroupsUrl());
    };

    return {
        showEditDialog,
        setShowEditDialog,
        showDeleteDialog,
        setShowDeleteDialog,
        onAddRecipientsClick,
        onDeleted,
    };
}
